import Label from "../Label/Label"

const InputText = (props: any) => {

	const input =  <input
			autoFocus={ props.autofocus ?? '' }
			autoComplete={ props.autocomplete ?? '' }
			id={ props.id }
			placeholder={ props.placeholder ?? '' }
			name={ props.name }
			className={ `default-input ${props.className}` }
			type={ props.type ?? 'text' }
			value={ props.value ?? '' }
			onKeyUp={(event) => {
				if(props.onKeyUp) {
					props.onKeyUp(event)
				}
			}}
			onChange={(event) => {
				if(props.onChange) {
					props.onChange(event);
				}
			}}
			onFocus={(event) => {
				if (props.onFocus) {
					props.onFocus(event);
				}
			}}
			onBlur={(event) => {
				if (props.onBlur) {
					props.onBlur(event);
				}
			}}
			readOnly={ props.readOnly }
			style={props.style}
		/>

		if(!props.tooltip && !props.tooltipHTML && !props.title && !props.label) {
			return input
		}

    return <Label
		tooltip={ props.tooltip }
		tooltipHTML={ props.tooltipHTML }
		title={ (props.title ?? (props.label ?? '')) + (props.required ? ' *' : '') }
	>
		{input}
	</Label>

}

export default InputText;
